import styled from "styled-components";

export const ContentTimeOrders = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentPercentage = styled.div`
  margin-right: 13px;
`;
